<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">批次</span>
                        <el-select
                            v-model="search_data.batch_no"
                            filterable
                            placeholder="请选择批次"
                            clearable
                            @visible-change="getCooperateBatchNoList"
                            @change="batchChange"
                            @keyup.enter.native="searchCooperateWineBatchLists"
                        >
                            <el-option label="全部" value=""></el-option>

                            <el-option
                                v-for="(item, index) in winList"
                                :key="index"
                                :label="'第' + item + '批次'"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">三方名称</span>
                        <el-select
                            v-model="search_data.third_id"
                            placeholder="请选择三方"
                            @visible-change="sfVisibleChange"
                            @change="sfChange"
                            @keyup.enter.native="searchCooperateWineBatchLists"
                            clearable
                        >
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in third" :key="item.third_id" :label="item.third_name" :value="item.third_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchCooperateWineBatchLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="add_isShow = !add_isShow">生成二维码</el-button>
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @row-contextmenu="rowContextmenu"
            @row-click="rowContextmenu"
        >
            <el-table-column prop="" label="批次" min-width="70">
                <template slot-scope="scope"> 第{{ scope.row.batch_no }}批次 </template></el-table-column
            >

            <el-table-column prop="num" label="数量" min-width="50"> </el-table-column>
            <el-table-column label="绑定三方" prop="third_name" min-width="80"></el-table-column>
            <el-table-column label="权益类型" prop="equity_type_name" min-width="70">
                <template slot-scope="scope"
                    ><div v-if="scope.row.equity_type == 2">{{ scope.row.equity_type_name }} : {{ scope.row.equity_amount }}元</div>
                    <div v-else>{{ scope.row.equity_type_name }}</div></template
                >
            </el-table-column>
        

            <el-table-column prop="insert_time.YmdHis" label="创建时间" min-width="60"> </el-table-column>

            <el-table-column label="操作" min-width="40">
                <!-- 下载按钮 这个loading index是获取列表接口cooperateWineBatchLists的时候自己加出来的-->
                <template slot-scope="scope">
                    <div class="export_btn">
                        <div>
                            <el-button v-if="scope.row.export_loading" icon="el-icon-loading" disabled></el-button>
                            <el-button v-else type="primary" @click.stop="toExport(scope.row.batch_no, scope.row.index)">导出</el-button>
                        </div>
                        <div style="margin-left: 10px">
                            <el-button v-if="scope.row.loading" icon="el-icon-loading" disabled></el-button>
                            <template v-else>
                                <el-button
                                    v-if="scope.row.zip_name != null"
                                    type="primary"
                                    @click.stop="toExportZip(scope.row.zip_name, scope.row.index)"
                                    >下载
                                </el-button>
                            </template>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>

        <!-- 添加组件 -->
        <addCooperateWine :isShow="add_isShow" @onSubmit="cooperateWineBatchLists"></addCooperateWine>
        <!-- 详情 -->
        <cooperateListDetail :isShow="detail_isShow" :data="batch_no"></cooperateListDetail>
    </div>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置
import addCooperateWine from './addCooperateWine.vue';
import cooperateListDetail from './cooperateListDetail.vue';
export default {
    components: {
        addCooperateWine,
        cooperateListDetail
    },
    data() {
        return {
            third: [],
            batch_no: '',
            zipName: '',
            winList: [],

            tableData: [],
            add_isShow: false,
            detail_isShow: false,
            srcList: [],
            search_data: {
                page: 1,
                limit: 10,
                batch_no: '',
                third_id: ''
            },
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;

        _this.searchCooperateWineBatchLists();
    },
    beforeDestroy() {
        clearTimeout(myTimer);
    },

    methods: {
        // 表格单击或者右键点击事件
        rowContextmenu(row, column, event) {
            _this.batch_no = row.batch_no;
            _this.detail_isShow = !_this.detail_isShow;

            // 阻止右键默认行为
            event.preventDefault();
        },

        // 导出
        toExport(batch_no, index) {
            _this.batch_no = batch_no;

            _this
                .$post('/Cooperatewine/cooperateListExportExcel', { batch_no: _this.batch_no })
                .then((res) => {
                    this.$message.success(res.msg);

                    _this.shuaXin(index);
                })
                .catch((err) => {});
        },
        shuaXin(index) {
            _this.tableData[index].export_loading = true;
         

            myTimer = setTimeout(() => {
                _this.cooperateWineBatchLists().then(() => {
                    if (_this.tableData[index].zip_name == null) {
                        _this.shuaXin(index);
                        
                    } else {
                        clearTimeout(myTimer);
                        _this.tableData[index].export_loading = false;
                        
                    }
                });
            }, 2000);
        },

        toExportZip(zip_name, index) {
            _this.tableData[index].loading = true;

            _this.zipName = zip_name;

            _this.downZipBusiness(index);
        },

        downZipBusiness(index) {
            axios({
                method: 'POST',
                url: config.axios_baseURL + '/business/downZipBusiness',

                data: {
                    zipName: _this.zipName
                },
                responseType: 'blob'
            })
                .then((response) => {
                    _this.tableData[index].loading = false;

                    const fileName = _this.zipName;
                    /* 兼容ie内核，360浏览器的兼容模式 */
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        window.navigator.msSaveOrOpenBlob(blob, 'fileName');
                    } else {
                        /* 火狐谷歌的文件下载方式 */
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a'); // 创建a标签
                        link.href = url;
                        link.download = fileName; // 文件重命名，若无需重命名，将该行删去
                        link.click();
                        URL.revokeObjectURL(url); // 释放内存
                    }
                    resolve(response);
                })
                .catch((error) => {
                    // _this.$errorMsg(error)
                });
        },

        // 二维码下载任务创建
        businessListExportExcel() {
            _this
                .$post('/business/businessListExportExcel', _this.search_data, _this.search_rules)
                .then((res) => {
                    this.$message.success(res.msg);
                })
                .catch((err) => {});
        },

        batchChange(val) {
            _this.search_data.batch_no = val;
            _this.cooperateWineBatchLists();
        },
        sfChange(val) {
            _this.search_data.third_id = val;
            _this.cooperateWineBatchLists();
        },
        sfVisibleChange(val) {
            if (val) {
                _this
                    .$post('/Cooperatewine/thirdAccountList')
                    .then((res) => {
                        _this.third = res.data;
                    })
                    .catch((err) => {});
            }
        },

        searchCooperateWineBatchLists() {
            _this.search_data.page = 1;
            _this.cooperateWineBatchLists();
        },

        async cooperateWineBatchLists() {
            await new Promise((resolve) => {
                _this
                    .$post('/Cooperatewine/cooperateWineBatchLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        for (let i = 0; i < res.data.length; i++) {
                            res.data[i].loading = false;
                            res.data[i].export_loading = false;
                            res.data[i].index = i;
                        }
                        _this.tableData = res.data;
                        _this.result_data = res;

                        resolve();
                    })
                    .catch((err) => {});
            });
        },
        getCooperateBatchNoList(val) {
            if(val) {
                _this
                .$post('/Cooperatewine/getCooperateBatchNoList')
                .then((res) => {
                    // _this.selectPages_data = res;
                    _this.winList = res.data;
                 
                })
                .catch((err) => {});

            }
            
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.cooperateWineBatchLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.cooperateWineBatchLists();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.cooperateWineBatchLists();
        },
        // 刷新页面
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
<style scoped>
.export_btn {
    display: flex;
    justify-content: left;
}
</style>